import{InjectionToken}from'@angular/core';
import { AppConfig } from './interfaces/app-config';

export const TT_LIB_CONFIG = new InjectionToken<AppConfig>(
    'TT_LIB_CONFIG'
    );